<template>

  <div>
    <div style="width: 100%;">
      <img src="../../productAndService/banner_01.png" alt="产品与服务" style="width: 100%; height: auto;">
    </div>

    <!-- 头部切换 -->
    <div class="wd100 pdtop" style="width: 1285px;margin: 40px auto;position: relative;">
      <div class="breadcrumb">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb-list">
            <li class="breadcrumb-item"><a @click="active('/')">首页></a></li>
            <li class="breadcrumb-item"><a href="#">产品与服务></a></li>
            <li class="breadcrumb-item">资质认定
            </li>
          </ol>
        </nav>
      </div>
      <div class="navigation">
        <div class="navigation-title">资质认定
        </div>
        <div class="navigation-links">
          <a href="#" class="navigation-link" :class="{ active: activeLink === 'gxShow' }"
             @click.prevent="selectLink('gxShow')">高新技术企业认定</a>
          <span class="separator">|</span>
          <a href="#" class="navigation-link" :class="{ active: activeLink === 'zjShow'  }"
             @click.prevent="selectLink('zjShow')">专精特新资质认定</a>
          <span class="separator">|</span>
          <a href="#" class="navigation-link" :class="{ active: activeLink === 'txShow' }"
             @click.prevent="selectLink('txShow')">体系认证</a>
        </div>
      </div>
    </div>

    <!--高新技术企业认定start******************************************************************************************************************************************************************************-->
    <div v-show="gxShow">
      <div class="wd100 pdtop text-containerdiv2">
        <div style="padding-top: 30px">
          <span style="font-size: 24px;font-weight: 800">高新技术企业认定的好处
          <span class="spanSty">Advantage</span></span>
        </div>

        <!-- 认定好处-->
        <div class="bqcontainer">
          <img src="./gxqy001.png" alt="背景图片" class="bqbackground-image">
          <div class="bqtext-overlay">
            <div class="bqbox">
              <p class="ph3" style="font-size: 16px;font-weight: 600;">百万资金无偿资助</p>
              <p>区资助</p>
              <p>市资助</p>
              <p>创新基金</p>
            </div>
            <div class="bqbox">
              <p class="ph3" style="font-size: 16px;font-weight: 600">多个税收优惠</p>
              <p>营业税</p>
              <p>增值税</p>
            </div>
            <div class="bqbox">
              <p class="ph3" style="font-size: 16px;font-weight: 600">国家补贴速到账</p>
              <p>10-30万补贴</p>
            </div>
            <div class="bqbox">
              <p class="ph3" style="font-size: 16px;font-weight: 600">优惠政策留住人才</p>
              <p>教育入学</p>
              <p>医疗保健</p>
              <p>购房补贴</p>
            </div>
            <div class="bqbox">
              <p class="ph3" style="font-size: 16px;font-weight: 600">上市有补贴</p>
              <p>信贷更方便</p>
            </div>
            <div class="bqbox" style="margin-right: 0">
              <p class="ph3" style="font-size: 16px;font-weight: 600">政府工程</p>
              <p>优先采购权</p>
            </div>
          </div>
        </div>

        <!--申请高新技术企业的基本条件-->
        <div style="position: absolute;margin-top:65px;width: 707px;">
        <span class="titleSty">申请高新技术企业的基本条件
        <span class="spanSty">Basic conditions</span></span>
          <p class="pstyle3">1、工商注册时间满一年；</p>
          <p class="pstyle2">2、拥有自主核心知识产权；</p>
          <p class="pstyle2">3、符合重点技术领域；</p>
          <p class="pstyle2">4、科技人员与研发人员占比；</p>
          <p class="pstyle2">5、研发费用占销售收入比例；</p>
          <p class="pstyle2">6、自主高新技术产品占总收入比例;</p>
          <p class="pstyle2">7、创新能力达到相应指标；</p>
          <p class="pstyle2">8、近一年在工商、环保、安全、质量上无重大违规。</p>
        </div>

        <!--企业认定所需要的材料-->
        <div style="position: absolute;margin-top:425px;width: 707px;">
        <span class="titleSty">企业认定所需要的材料
        <span class="spanSty">Required materials</span></span>
          <p class="pstyle3">1、员工学历证书；</p>
          <p class="pstyle2">2、财务报表；</p>
          <p class="pstyle2">3、税务纳税报表；</p>
          <p class="pstyle2">4、公司资质证书；</p>
          <p class="pstyle2">5、研发场地与设备照片。</p>
        </div>

        <div style="position: absolute;margin-top: 680px;width: 707px;">
          <span class="titleSty">安贝森优势
          <span class="spanSty">Our advantage</span></span>
        </div>
        <AdvantageList customStyle="position: absolute;margin-top: 720px;width: 1200px;margin-left: -25px;"/>
      </div>
    </div>
    <!--高新技术企业认定end******************************************************************************************************************************************************************************-->


    <!--专精特新资质认定start******************************************************************************************************************************************************************************-->
    <div v-show="zjShow">
      <div class="wd100 pdtop text-containerdiv2" style="height: 1800px">

        <img src="./zj001.png" alt="背景图片" class="bqbackground-image" style="margin-top: 30px">

        <div style="padding-top: 30px">
          <span style="font-size: 24px;font-weight: 800">申报“专精特新”的好处
          <span class="spanSty">Advantage</span></span>
        </div>
        <div class="benefits-container">
          <div class="benefit-item">
            <img src="./zj002.png" alt="优先获得直接资金扶持" class="benefit-icon">
            <div class="benefit-text">
              <h3>优先获得直接资金扶持</h3>
              <p>补贴:最高<span style="color: #0788dc;">1000万</span>资金补贴</p>
            </div>
          </div>
          <div class="benefit-item">
            <img src="./zj003.png" alt="政府招标采购优先参与" class="benefit-icon">
            <div class="benefit-text">
              <h3>政府招标采购优先参与</h3>
              <p>贷款:低息贷款、担保贷款额度</p>
            </div>
          </div>
          <div class="benefit-item">
            <img src="./zj004.png" alt="利于企业宣传、市场开拓" class="benefit-icon">
            <div class="benefit-text">
              <h3>利于企业宣传、市场开拓</h3>
              <p>融资:<span style="color: #0788dc;">北交所</span>优先上市扶持</p>
            </div>
          </div>
        </div>

        <!--申请高新技术企业的基本条件-->
        <div style="position: absolute;margin-top:65px;width: 707px;">
          <span class="titleSty">申请的基本条件
          <span class="spanSty">Basic conditions</span></span>

          <div class="tj-container">
            <div class="tj-box">
              <div class="tj-header">专精特新中小企业</div>
              <div class="tj-content">
                <div class="tj-item"><img src="./zj005.png" alt="✓">从事细分市场2年以上</div>
                <div class="tj-item"><img src="./zj005.png" alt="✓">年营业收入1000万元以上</div>
                <div class="tj-item"><img src="./zj005.png" alt="✓">研发费用产比大于3%</div>
              </div>
            </div>

            <div class="tj-box">
              <div class="tj-header">专精特新“小巨人”企业</div>
              <div class="tj-content">
                <div class="tj-item"><img src="./zj005.png" alt="✓">从事特定细分市场3年以上</div>
                <div class="tj-item"><img src="./zj005.png" alt="✓">位于产业链关键环节，发挥补短板、锻长板、填空白等作用</div>
                <div class="tj-item"><img src="./zj005.png" alt="✓">至少1项核心业务采用信息系统支撑，取得相关管理体系认证</div>
                <div class="tj-item"><img src="./zj005.png" alt="✓">产品在全国市场占有率达到10%以上，主营业务收入占比不低于70%。</div>
              </div>
            </div>
          </div>

        </div>

        <!--企业认定所需要的材料-->
        <div style="position: absolute;margin-top:425px;width: 707px;">
        <span class="titleSty">申报所需要的材料
        <span class="spanSty">Required materials</span></span>
          <p class="pstyle3">1、员工学历证书；</p>
          <p class="pstyle2">2、财务报表；</p>
          <p class="pstyle2">3、税务纳税报表；</p>
          <p class="pstyle2">4、公司资质证书；</p>
          <p class="pstyle2">5、研发场地与设备照片。</p>
        </div>

        <div style="position: absolute;margin-top: 680px;width: 707px;">
          <span class="titleSty">安贝森优势
          <span class="spanSty">Our advantage</span></span>
        </div>
        <AdvantageList customStyle="position: absolute;margin-top: 720px;width: 1200px;margin-left: -25px;"/>
      </div>
    </div>
    <!--专精特新资质认定end******************************************************************************************************************************************************************************-->

    <!--体系认定start******************************************************************************************************************************************************************************-->
    <div v-show="txShow">
      <div class="wd100 pdtop text-containerdiv0" style="height: 300px">
        <div class="tx-content-section" style="height: 300px">
          <div class="tx-content-box">
            <div class="tx-content-box-title">ISO体系</div>
            <img src="./tx001.png" alt="ISO体系"/>
          </div>
          <div class="tx-content-box tx-border" style="width: 129px;height: 159px;padding-top: 15px;">
            <ul>
              <li>商标转让介绍</li>
              <li>申请所需资料</li>
              <li>所需时间</li>
              <li>所需费用</li>
              <li>办理流程</li>
              <li>安贝森优势</li>
            </ul>
          </div>

          <div class="tx-content-box">
            <div class="tx-content-box-title">知识产权贯标</div>
            <img src="./tx002.png" alt="知识产权贯标"/>
          </div>

          <div class="tx-content-box">
            <div class="tx-content-box-title">AAA信用认证</div>
            <img src="./tx003.png" alt="AAA信用认证"/>
          </div>
          <div class="tx-content-box">
            <div class="tx-content-box-title">两化融合贯标</div>
            <img src="./tx004.png" alt="两化融合贯标"/>
          </div>
          <div class="tx-content-box">
            <div class="tx-content-box-title">信息系统集成资质</div>
            <img src="./tx005.png" alt="信息系统集成资质"/>
          </div>
          <div class="tx-content-box">
            <div class="tx-content-box-title">CCRC信息安全</div>
            <img src="./tx006.png" alt="CCRC信息安全"/>
          </div>
        </div>
      </div>

<!--      ISO体系认证介绍-->
      <div class="wd100 pdtop text-containerdiv3" style="height: 1800px">
        <div style="padding-top: 30px">
          <span style="font-size: 24px;font-weight: 800">ISO认证体系介绍
          <span class="spanSty">Introduce</span></span>
        </div>
        <div class="tixi-container">
          <div class="tixi-left-box">
            <img src="./tx007.png" alt="ISO体系认证" class="tixi-iso-image">
            <div class="tixi-text-content">
              <p>由业内资深的咨询顾问为客户提供专业的ISO体系咨询辅导一站式服务，并为企业甄选可充分信任的第三方认证机构为企业管理体系运行活动实施评审计认证。</p>
            </div>
          </div>

          <div class="tixi-right-box">
            <div class="tixi-item">
              <img src="./tx008.png" alt="QMS" class="tixi-icon">
              <span class="tixi-title">QMS</span>
              <span class="tixi-description">ISO 9001:2015质量管理体系</span>
            </div>
            <div class="tixi-item">
              <img src="./tx009.png" alt="EMS" class="tixi-icon">
              <span class="tixi-title">EMS</span>
              <span class="tixi-description">ISO 14001:2015环境管理体系</span>
            </div>
            <div class="tixi-item">
              <img src="./tx010.png" alt="OHSMS" class="tixi-icon">
              <span class="tixi-title">OHSMS</span>
              <span class="tixi-description">ISO 45001:2018职业健康安全体系</span>
            </div>
          </div>
        </div>

        <!--认证的意义-->
        <div style="position: absolute;margin-top:65px;width: 1255px;">
          <span class="titleSty">ISO认证的意义
          <span class="spanSty">Significance</span></span>

          <div class="bqcontainer-2">
            <img src="./tx011.png" alt="背景图片" class="bqbackground-image-2">
            <div class="bqtext-overlay-2">
              <div class="bqbox-2">
                <p>提升企业市场竞争力.企业通过ISO体系认证实现规</p>
                <p>范化管理，提升整体管理水平，提高企业风险应对</p>
                <p>能力，最终提升企业核心竞争力。</p>
              </div>
              <div class="bqbox-2" style="padding-left: 34px">
                <p>政府采购、供应商评定、高企等资质认定：目前政</p>
                <p>府采购招投标、合格供应商评价、高新技术企业认</p>
                <p>定、绿色工厂认定等，已将企业ISO三基础体系认</p>
                <p>证做为重要参考指标评定依据。</p>
              </div>
              <div class="bqbox-2" style="padding-left: 31px">
                <p>满足政府法律要求，获取国际贸易的绿色通行证</p>
                <p>：ISO14001体系强调企业通过污染预防，环境保</p>
                <p>护，来树立优秀的企业形象，改进产品性能，制造</p>
                <p>绿色产品，以此增强企业竞争力，扩大市场份额。</p>
              </div>
            </div>
          </div>

        </div>

        <!--ISO项目开展-->
        <div style="position: absolute;margin-top: 515px;width: 1255px">
          <span class="titleSty">ISO项目开展
          <span class="spanSty">Project implementation</span></span>
        </div>
        <div style="width: 1255px;position: absolute; margin-top: 600px;">
          <div class="process-container">
            <img src="./tx012.png" alt="背景图片" class="process-background-image">

            <div class="process-text-overlay">
              <div class="process-step-1">
                <div class="process-title-vertical">前期策划</div>
                <p class="process-description" style="line-height: 2">● 企业调研 ● 文件编写</p>
                <p class="process-description" style="line-height: 2">● 项目宣贯 ● 体系培训</p>
              </div>
              <div class="process-step-1">
                <div class="process-title-vertical">体系运行</div>
                <p class="process-description" style="line-height: 2">● 运行实施 ● 运行记录</p>
                <p class="process-description" style="line-height: 2">● 运行监测 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
              </div>
              <div class="process-step-1">
                <div class="process-title-vertical">检查监测</div>
                <p class="process-description" style="line-height: 2">● 内审培训 ● 管理评审</p>
                <p class="process-description" style="line-height: 2">● 问题整改 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
              </div>
              <div class="process-step-1">
                <div class="process-title-vertical">外审认证</div>
                <p class="process-description" style="line-height: 2">● 服务优势 ● 不符整改</p>
                <p class="process-description" style="line-height: 2">● 现成审核 ● 获取证书</p>
              </div>
            </div>

          </div>
        </div>

        <div style="position: absolute;margin-top: 800px;width: 707px;">
          <span class="titleSty">安贝森优势
          <span class="spanSty">Our advantage</span></span>
        </div>
        <AdvantageList customStyle="position: absolute;margin-top: 860px;width: 1200px;margin-left: -25px;"/>
      </div>
    </div>
    <!--体系认定end******************************************************************************************************************************************************************************-->

    <div class="wd100 pdtop" style="width: 1255px;margin: 0px auto;height:150px">
    </div>
  </div>


</template>
<style scoped>
@import 'qualifications.css';
</style>
<script>
import {save} from '@/api/common'
import AdvantageList from "../common/advantageList.vue";

export default {
  components: {AdvantageList},
  data() {
    return {
      activeLink: 'gxShow',
      gxShow: true,
      zjShow: false,
      txShow: false,
    }
  },

  methods: {
    selectLink(link) {

      // 重置所有模块的显示状态为 false
      this.gxShow = false;
      this.zjShow = false;
      this.txShow = false;

      // 根据点击的链接设置对应模块的显示状态为 true
      if (link === 'gxShow') {
        this.gxShow = true;
      } else if (link === 'zjShow') {
        this.zjShow = true;
      } else if (link === 'txShow') {
        this.txShow = true;
      }

      this.activeLink = link; // 更新当前选中的链接

    },
  },
  mounted: function () {

  },
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/service/qualifications/qualifications.vue